import { useTranslation } from 'react-i18next'
import styles from './CurrentTime.module.scss'

export const CurrentTime = ({ time }) => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <span className={styles['label']}>{t('main.currentTime')}</span>
      <span className={styles['time']}> {time}</span>
    </div>
  )
}
